<template>
  <div class="status-section">

    <label><strong>Author:</strong> {{ tutorial.author }}</label>


    <label><strong>Created:</strong> {{ tutorial.date }}</label>
    <label><strong>Updated:</strong> {{ tutorial.date }}</label>

  </div>
</template>

<script>
export default {
  name: "StatusSection",
  props: {
    tutorial: {
      type: Object,
      required: true,
    },
    updatePublished: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style scoped>
.status-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  font-size: 16px;
  margin: 20px 0;
  color: var(--my-border);
}

.status label {
  margin-right: 10px;
}
</style>
